import DashboardLayout from "../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../examples/Footer";
import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import * as React from 'react';
import MDButton from "../../../../components/MDButton";
import MDBox from "../../../../components/MDBox";
import Stepper from "@mui/material/Stepper";
import StepLabelClass from "../../../../assets/theme/components/stepper/stepLabel";
import {
    Paper,
    StepLabel,
    StepContent,
    stepLabelClasses,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText, DialogActions
} from "@mui/material";
import MDInput from "../../../../components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";

import FormField from "layouts/pages/account/components/FormField";
import DataTable from "../../../../examples/Tables/DataTable";
import MDTypography from "../../../../components/MDTypography";
import Card from "@mui/material/Card";
import MDDatePicker from "../../../../components/MDDatePicker";
import TextField from "@mui/material/TextField";
import {
    bookElevatorColumns,
    dayNames,
    elevatorColumns,
    userDashboardColumns
} from "../../../../components/Utils/HeaderColumns";
import dayjs from "dayjs";
import {useState} from "react";
import ElevatorsService from "../../../../services/elevators.service";
import MDSnackbar from "../../../../components/MDSnackbar";
import GHIconButton from "../../../../components/GHIconButton";
import Icon from "@mui/material/Icon";



function BookElevator() {

    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const openInfoSB = () => setInfoSB(true);
    const closeInfoSB = () => setInfoSB(false);
    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);
    const renderSB  = () => (
        <div>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Amenity System"
              content="Your data saved successfully"
              dateTime=""
              open={infoSB}
              onClose={()=>setInfoSB(false)}
              close={()=>setInfoSB(false)}  />

            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={()=>setErrorSB(false)}
              close={()=>setErrorSB(false)}/>
        </div>
    );
    const [date,setDate] = useState("")
    const [startTime,setStartTime] = useState("")
    const [endTime,setEndTime] = useState("")
    const [elevators, setElevators] = React.useState([]);
    const [selectedElevator, setSelectedElevator] = React.useState(null);
    const loadElevators = () =>{
        ElevatorsService.getElevators()
            .then((res) => {
                console.log(res.data)
                setElevators(res.data || []);
                  if (Array.isArray(res.data) && res.data.length > 0) {
                    setSelectedElevator(res.data[0]);
                  } else {
                    setSelectedElevator(null);
                  }
            })
            .catch((reason) => {
              console.log(reason);

              const msg =
                  reason?.response?.data?.status ??
                  reason?.response?.data?.message ??
                  reason?.message ??
                  "Failed to load elevators";

              setErrorMessage(msg.toString());
              openErrorSB();
          });
    }
    const selectStartDate = (e)=>{
        console.log(e);
    }
    const selectStartTime = (e)=>{
        alert(e);
    }
    const selectEndDate = (e) =>{
        console.log(e);
    }
    let currentDate = new Date().getFullYear().toString() + "-" + (new Date().getMonth()+1).toString() + "-" + new Date().getDate().toString()
    let maxDate = new Date().getFullYear().toString() + "-" + (new Date().getMonth()+1).toString() + "-" + (new Date().getDate() + 10).toString()
    // alert(currentDate)
    let steps = [
          {
              label: 'Select Elevator',
              description: ``,
              input:<Grid item xs={12} mb={2} sm={12} sx={{ mt: 2 }} color={"white"} bgcolor={"white"} >
                    <MDBox variant="gradient" color={"white"} borderRadius="md" shadow="md" coloredShadow={"dark"} >
                        <Autocomplete
                          value={selectedElevator}
                          options={elevators}
                          onChange={(e, v) => setSelectedElevator(v)}
                          getOptionLabel={(option) => option?.name || ""}
                          isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                          renderInput={(params) => <TextField {...params} />}
                        />
                    </MDBox>
                  </Grid>
          },
          {
                label: 'Select Date',
                description: '' ,
                input:
                    <Grid container spacing={3} mb={2}>
                      <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                          <MDBox variant="gradient" color={"white"} borderRadius="md" shadow="md" coloredShadow={"dark"} >
                          <MDDatePicker
                              fullWidth
                              value={date}
                              onChange={(date)=>setDate(date[0])}
                              input={{ placeholder: "Select Date" }}
                                options={{
                                    minDate: currentDate,
                                    maxDate:maxDate,
                                    enableTime: false,
                                    altInput: true,
                                    position: 'below',
                                }}/>
                    </MDBox>
                      </Grid>
                    </Grid>
          },
          {
            label: 'Select Time',
            description:'',
            input: <Grid container spacing={3} mb={2}>
                      <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                          <MDBox variant="gradient" color={"white"} borderRadius="md" shadow="md" coloredShadow={"dark"} >
                              <FormField
                                onChange={e => setStartTime(e.target.value)}
                                value={startTime}
                                label="Start Time"
                                placeholder="18:30"
                                sx={{"margin":"10px"}}
                                type={"time"} />
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                          <MDBox variant="gradient" color={"white"} borderRadius="md" shadow="md" coloredShadow={"dark"} >

                              <FormField
                                onChange={e => setEndTime(e.target.value)}
                                value={endTime}
                                label="End Time"
                                placeholder="18:30"
                                sx={{"margin":"10px"}}
                                type={"time"} />
                         </MDBox>
                      </Grid>
                    </Grid>
          },
          {
            label: 'Create Booking',
            description: `Do you confirm Elevator Term ?`,
            input:<></>
          },
    ];



    const [activeStep, setActiveStep] = React.useState(0);

    const [elevatorBooking, setElevatorBooking] = React.useState([]);

    const handleNext = () => {
        if (activeStep === steps.length - 1){
           if (!selectedElevator?.id) {
              setErrorMessage("Please select an elevator");
              openErrorSB();
              return;
            }
            if (!date) {
              setErrorMessage("Please select a date");
              openErrorSB();
              return;
            }
            if (!startTime || !endTime) {
              setErrorMessage("Please select start/end time");
              openErrorSB();
              return;
            }

            let data = {
              elevator: selectedElevator.id,   // بدون toString
              date: date,                      // بدون toString
              start: startTime,
              end: endTime,
            };
            ElevatorsService.bookElevator(data)
                .then((value)=>{
                    openInfoSB();
                    window.location.reload();
                })
                .catch((reason)=>{
                    setErrorMessage(reason.response.data.status.toString());
                    openErrorSB();
                });
        }else{
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handleFinish = () => {setActiveStep((prevActiveStep) => prevActiveStep + 1);};

    const handleBack = () => {setActiveStep((prevActiveStep) => prevActiveStep - 1);};

    const handleReset = () => {setActiveStep(0);};



    const [clickedItemId, setClickedItemId] = useState(0);


    const handleOpen = (event, model) => {
        switch (model){
            case "cancel":
                handleOpenDialog(model);
                break;
        }
    }

    const [openDialog, setOpenDialog] = useState(false);
    const [dialogAction, setDialogAction] = useState("");
    const handleOpenDialog = (action) => {
        setOpenDialog(true);
        setDialogAction(action)
    }
    const handleCloseDialog = () => setOpenDialog(false);

    const handleAgreeDeleteDialog = () => {
        if (dialogAction === "cancel") {
            ElevatorsService.cancelBookElevator(clickedItemId)
                .then((response) => {
                    openInfoSB();
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMessage(err);
                    openErrorSB();
                });

        }
    }


    const renderDialog = () => {
        return (
            <Dialog
                open={openDialog}
                keepMounted
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle><Icon color={"warning"} >warning</Icon>{" Delete/Disable confirmation"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure to Delete/Disable this item ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={handleCloseDialog} >Disagree</MDButton>
              <MDButton onClick={handleAgreeDeleteDialog}  size={"large"}  color={"info"}  >Agree</MDButton>
            </DialogActions>
          </Dialog>
        )
    }


    const clickItem = (elem) =>{
        let actionToDo = elem.target.getAttribute("action");
        let rowId = elem.target.id;
        setClickedItemId(rowId);
        switch (actionToDo) {
            case "cancel":
                handleOpen(elem,"cancel");
                break;
        }
    }
    const [elevatorTableData, setElevatorTableData] = useState({"columns" : bookElevatorColumns, "rows":[]});
    const loadElevatorBooking = () => {
        setElevatorTableData({"columns" : bookElevatorColumns, "rows":[]})
        ElevatorsService.getMyElevatorBooking()
        .then((res) => {
            console.log(res.data);
            setElevatorTableData( {
                "columns": bookElevatorColumns,
                "rows": res.data.map(function(element) {
                        return {
                              id: element.id,
                              // unit: element.unit,
                              elevator: element.elevator,
                              date: element.date,
                              start: element.start_time,
                              end: element.end_time,
                              action: (
                                  <div>
                                      <GHIconButton onClick={clickItem} rowName={element.id + ""} id={ element.id} action={"cancel"}
                                                    title={"Cancel Booking"} color={"error"}
                                                    icon={"cancel"} size={"medium"} />
                                  </div>
                              ),
                            }
                    })
            })

        })
        .catch((error) => {
          console.log(error);
        });
    }

    React.useEffect(()=>{
      loadElevators();
      loadElevatorBooking();
    }, []);
    const renderMain = () => {
        return (
            <Card>
                {renderDialog}
                {renderSB}
                <MDTypography ml={2} variant="h3" fontWeight="medium" color="dark" mt={1}></MDTypography>
                <MDBox mt={2} pb={3} px={2}>

                      <Grid container  spacing={3}>
                        <Grid item xs={12} md={4}>
                           <MDBox coloredShadow={"dark"}  variant={"gradient"} shadow={2} borderRadius={"3"}   >
                              <Stepper elevation={2} aria-busy={"true"}  activeStep={activeStep} orientation="vertical" nonLinear={true}
                                       autoSave={true} sx={{"padding":1}} >
                                {steps.map((step, index) => (
                                  <Step key={step.label}>
                                    <StepLabel sx={StepLabelClass}
                                      optional={null }
                                    >
                                      {step.label}
                                    </StepLabel>
                                    <StepContent sx={{"marginLeft":0.85,color:"white"}} >
                                      <Typography variant={"h5"} color={"#ffffff"} sx={{"marginBottom":1.3}}>{step.description}</Typography>
                                        {step.input}
                                      <MDBox sx={{ mb: 2 }}>
                                        <div>
                                          <MDButton
                                            variant="contained"
                                            onClick={handleNext}
                                            sx={{ mt: 1, mr: 1 }}
                                          >
                                            {index === steps.length - 1 ? 'Confirm And Book' : 'Continue'}
                                          </MDButton>
                                          <MDButton
                                              variant={"outlined"}
                                            disabled={index === 0}
                                            onClick={handleBack}
                                            sx={{ mt: 1, mr: 1 }}
                                          >
                                            Back
                                          </MDButton>
                                        </div>
                                      </MDBox>
                                    </StepContent>
                                  </Step>
                                ))}
                              </Stepper>
                              {activeStep === steps.length && (
                                <Paper square elevation={0} sx={{ p: 3 }}>
                                  <Typography>All steps completed - you&apos;re finished</Typography>
                                  <MDButton onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                                    Book New Elevator
                                  </MDButton>
                                </Paper>
                              )}
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={8} minHeight={"220px"}>
                          <MDBox coloredShadow={"dark"}  variant={"gradient"} shadow={2} borderRadius={"3"}   >
                            <Card  >
                                <MDTypography sx={{"marginLeft":2, "marginTop":2, "marginBottom":2,}}
                                              color={"dark"} fontWeight={"bold"} >Old Reserved Data</MDTypography>
                                <DataTable
                                 table={elevatorTableData}
                                    canSearch={false}
                                 showTotalEntries={false}
                                 entriesPerPage={false}
                                 noEndBorder={false}
                                 isSorted={true} />
                            </Card>
                          </MDBox>
                        </Grid>
                      </Grid>
                </MDBox>
            </Card>
          );
    }

    return (
        <DashboardLayout>
          <DashboardNavbar />
          {renderMain()}
          <Footer />
        </DashboardLayout>
      );
}

export default BookElevator;